{
    "name": "Fava Bean",
    "binomial_name": "Vicia faba",
    "common_names": [
        "broad bean",
        "fava bean",
        "faba bean",
        "field bean",
        "bell bean",
        "English bean",
        "horse bean",
        "Windsor bean",
        "pigeon bean",
        "tic bean",
        "tick bean"
    ],
    "description": "The fava, or broad bean, is a species of flowering plant in the vetch and pea family Fabaceae. Unlike most beans, fava beans thrive in cooler weather and do not require trellising. They should be planted in early spring as soon as the soil can be worked. The broad, leathery pods contain 3-8 beans and grow on stiff stems that can reach heights of 1.8m.  Fava are planted for their edible beans, or as a cover crop to reduce winter erosion and increase nitrogen in the soil. Inoculants can increase yield and nitrogen production. The pods are commonly harvested while young, when they are about 15cm long. Fava beans are eaten in a myriad of ways: raw in salads, grilled, roasted, fried, pureed, and more.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Direct seed outdoors",
    "spread": 0,
    "row_spacing": 12,
    "height": 120,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/fava-bean.jpg",
    "icon": "/crops/icons/fava-bean.avif"
}